import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import localeText from "../../locale";
import { useContext } from "react";
import { CartContext } from "../../contexts/CartContext/CartContext";
import { useLocation } from "react-router-dom";
import LanguageSelectionButton from "../LanguageSelectionButton/LanguageSelectionButton";
import { use } from "react";
import { useMediaQuery } from "react-responsive";
import UserIcon from "./UserIcon";
import UserIconAlt from "./UserIconAlt";

const NavLinks = ({ isAdmin, userInfo, loadingUserInfo, favoritesCount, hasSearch }) => {
  const { cartItemCount } = useContext(CartContext);

  const url = useLocation();

  const isFringeBenefitsPage = url?.pathname?.toLowerCase()?.includes("fringe");

  const cartUrl = isFringeBenefitsPage ? "/cart-fringe-benefit" : "/cart";

  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <nav
      className={`align-items-center gap-2 md:gap-3 flex col ${
        hasSearch ? "md:col-fixed" : ""
      }  justify-content-end`}
    >
      <div className="text-center lg:mt-1 lg:ml-0">
        {isMobile ? (
          <>
            {userInfo ? (
              <Link className="flex align-items-center" to="/dashboard">
                <UserIcon />
              </Link>
            ) : (
              <Link className="flex align-items-center" to="/login">
                <UserIconAlt />
              </Link>
            )}
          </>
        ) : (
          <div>
            {userInfo && (
              <div className="text-left flex flex-column gap-1">
                <Link className="text-xs text-white hover:underline" to="/dashboard">
                  {localeText("hello")},{" "}
                  {isAdmin ? userInfo?.result?.user?.firstname : userInfo?.firstname}
                </Link>
                <Link
                  to="/dashboard-purchases"
                  className="text-white text-sm font-bold hover:underline"
                >
                  {localeText("myOrders")}
                </Link>
              </div>
            )}
            {!userInfo && (
              <>
                {loadingUserInfo ? (
                  <i className="pi pi-spin pi-spinner ml-3 text-600 text-xl"></i>
                ) : (
                  <div className="text-left flex flex-column">
                    <div className="text-white text-xs hidden md:block">{localeText("hello")}</div>
                    <div className="flex align-items-center">
                      <Link to="/login" className="text-white text-sm font-bold underline">
                        {localeText("login")}
                      </Link>
                      <span className="mx-1 text-white hidden md:block">{localeText("or")}</span>
                      <Link
                        to="/specialcustomer"
                        className="text-white text-sm font-bold underline hidden md:block"
                      >
                        {localeText("register")}
                      </Link>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
      <div>
        <LanguageSelectionButton storePage={true} />
      </div>
      <div className="flex align-items-center gap-3">
        {userInfo && !isFringeBenefitsPage && (
          <Link to="/dashboard-favorites" className="hidden md:block">
            <span className="uppercase flex align-items-center font-medium">
              <i className="pi pi-heart text-xl text-white"></i>
              {!!favoritesCount && favoritesCount !== -1 && (
                <div
                  className="flex align-items-center justify-content-center absolute border-circle text-xs"
                  style={{
                    background: "#FFC839",
                    color: "#204C21",
                    marginLeft: ".9rem",
                    marginBottom: "1.4rem",
                    height: "1rem",
                    width: "1rem",
                  }}
                >
                  {favoritesCount}
                </div>
              )}
              {/* <span className="button-blank color-dark-gray">{localeText("favorites")}</span> */}
            </span>
          </Link>
        )}
        <Link to={cartUrl} className="">
          <span className="uppercase flex align-items-center font-medium">
            <i className="pi pi-shopping-cart text-xl text-white"></i>
            {cartItemCount > 0 && (
              <div
                className="flex align-items-center justify-content-center absolute border-circle text-xs"
                style={{
                  background: "#FFC839",
                  color: "#204C21",
                  marginLeft: ".9rem",
                  marginBottom: "1.4rem",
                  height: "1rem",
                  width: "1rem",
                }}
              >
                {cartItemCount}
              </div>
            )}
          </span>
        </Link>
      </div>
    </nav>
  );
};

export default NavLinks;
